module.exports = __webpack_public_path__ + "static/media/28.b5769816.jpg";